"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef, useEffect } from "react";
import { Box } from "@mui/material";
import { styles } from "./styles.js";
const COMPONENT_NAME = "AnnouncerModel";
const AnnouncerModel = forwardRef(
  (props, ref) => {
    const {
      announcerText,
      announcerTime = 500,
      ariaLive = "polite",
      ariaAtomic = true,
      callback,
      ...rest
    } = props;
    useEffect(() => {
      const messageTimeout = setTimeout(() => {
        callback("");
      }, announcerTime);
      return () => {
        clearTimeout(messageTimeout);
      };
    }, [announcerText, announcerTime, callback]);
    return /* @__PURE__ */ jsx(
      Box,
      {
        "aria-live": ariaLive,
        "aria-atomic": ariaAtomic,
        ref,
        sx: {
          ...styles
        },
        "data-testid": "Screen Announcer",
        ...rest,
        children: announcerText
      }
    );
  }
);
AnnouncerModel.displayName = COMPONENT_NAME;
export {
  AnnouncerModel
};
